import { BulkAction, DataService, ItemOf, ModalService, NotificationService } from '@vendure/admin-ui/core';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DeleteReferralDocument, GetReferralsListQuery, Permission } from '../../generated-types';

export const deleteReferralBulkAction: BulkAction<ItemOf<GetReferralsListQuery, 'referrals'>> = {
    location: 'referral-list',
    label: 'Delete',
    icon: 'trash',
    iconClass: 'text-danger',
    requiresPermission: Permission.SuperAdmin,
    onClick: ({ injector, selection, clearSelection, hostComponent }) => {
        const modalService = injector.get(ModalService);
        const dataService = injector.get(DataService);
        const notificationService = injector.get(NotificationService);

        const referralNames = selection.map(referral => referral.firstName ?? '').join(', ');

        modalService
            .dialog({
                title: 'Confirm Delete Referrals',
                body: `Are you sure you want to delete these Referrals (${referralNames})?`,
                buttons: [
                    { type: 'secondary', label: 'Cancel' },
                    { type: 'danger', label: 'Delete', returnValue: true },
                ],
            })
            .pipe(
                switchMap(response =>
                    response
                        ? dataService.mutate(DeleteReferralDocument, {
                              ids: selection.map(f => f.id),
                          })
                        : EMPTY,
                ),
            )
            .subscribe({
                next: res => {
                    if (res.deleteReferral?.result === 'DELETED') {
                        notificationService.success('All selected Referrals deleted successfully.');
                    } else {
                        notificationService.error(
                            res.deleteReferral?.message || 'Failed to delete Referrals.',
                        );
                    }
                    clearSelection();
                    hostComponent?.refresh?.();
                },
                error: () => {
                    notificationService.error('An unexpected error occurred while deleting Referrals.');
                    clearSelection();
                },
            });
    },
};
